import { EnvironmentProviders, InjectionToken, makeEnvironmentProviders } from '@angular/core';
import { ApiCollectionService } from '../services/api-collection-export.service';
import { BrunoApiCollectionService } from '../services/bruno-collection-export.service';
import { PostmanApiCollectionService } from '../services/postman-collection-export.service';

export const API_COLLECTION_SERVICES = new InjectionToken<ApiCollectionService[]>('api-collection-export-services');

export const provideApiApiCollectionServices = (): EnvironmentProviders => {
  return makeEnvironmentProviders([
    {
      provide: API_COLLECTION_SERVICES,
      useClass: PostmanApiCollectionService,
      multi: true,
    },
    {
      provide: API_COLLECTION_SERVICES,
      useClass: BrunoApiCollectionService,
      multi: true,
    },
  ]);
};
